module.exports = __webpack_public_path__ + "img/chatbot3.af93e7d1.svg";